export default "__VITE_ASSET__8R5eBtcf__"